import React from 'react';
import { Avatar, List } from 'react-native-paper';
import { t } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';

import { i18n } from '@src/i18n';
import { Hashtag } from '@src/types';

type Props = {
  item: Hashtag;
};

const Component: React.FC<Props> = ({ item }) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    // @ts-ignore
    () => navigation.push('Hashtag', { name: item.name }),
    [item.name, navigation]
  );

  return (
    <List.Item
      onPress={handlePress}
      title={item.name}
      description={i18n._(t`${item.count} posts`)}
      left={(props) => <Avatar.Icon {...props} icon="hashtag" size={50} />}
    />
  );
};

Component.displayName = 'HashtagCard';

export default React.memo(Component);
